import React from 'react'
import raw from 'raw.macro'
import Markdown from '../Markdown'

interface Props {
  target: 'Privacy' | 'Terms' | 'Help'
}

// NOTE:CRAでmarkdownをimportする術はまだないのでraw.macroを採用する
// https://qiita.com/qrusadorz/items/df673e1aa49f7656dc77
const markdowns = {
  Help: raw('../../../markdowns/Help.md'),
  Privacy: raw('../../../markdowns/Privacy.md'),
  Terms: raw('../../../markdowns/Terms.md')
}

const Component: React.FC<Props> = ({ target }) => <Markdown>{markdowns[target]}</Markdown>

export default Component
